module.exports = __webpack_public_path__ + "img/call-center.f87543f1.png";